import React from 'react';
import { SkipNavLink, SkipNavContent } from '@reach/skip-nav';

import DarkOverlay from '@common/DarkOverlay';
import Header from '@components/blog/header/Header';
import Footer from '@components/blog/footer/Footer';

const BlogLayout = ({ children }) => {
  return (
    <>
      <Header />
      <DarkOverlay/>
      <SkipNavLink>{'Skip to Content'}</SkipNavLink>
      <SkipNavContent>{children}</SkipNavContent>
      <Footer />
    </>
  )
}

export default BlogLayout
